import styled from 'styled-components';
export const CustomVideo = styled.video `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map